module.exports = __webpack_public_path__ + "static/99-0ea91fee1ab4d62c3c5fe9bb398e8d4d.jpg";